export default {
  painManagement: {
    title: 'Which area are you experiencing pain?',
    validation: {
      required: 'Please select an option',
    },
    painOptions: {
      neck: 'Neck Pain',
      lowerBack: 'Lower Back Pain',
      both: 'Both Neck and Lower Back Pain',
      none: 'No Back or Neck Pain',
    },
    submit: 'Submit',
  },
};
